import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
// core components
import Header from "components/Header/Header.js";
import Footer from "components/SiteFooter/Footer.js";
import HeaderLinks from "components/SiteHeader/HeaderLinks.js";

import styles from "assets/jss/material-kit-react/views/landingPage.js";

// Sections for this page
import MunicipalityInfo from "./Sections/MunicipalityInfo.js";
import Brand from "../Brand.js";

const dashboardRoutes = [];
const useStyles = makeStyles(styles);

export default function LandingPage(props) {
  const classes = useStyles();
  const { ...rest } = props;

  React.useEffect(() => {
    window.scrollTo(0, 0)
  });

  return (
    <div>
      <Header
        color="primary"
        routes={dashboardRoutes}
        brand=<Brand />
        shrink_brand=<Brand shrink={true}/>
        rightLinks={<div><HeaderLinks /></div>}
        // fixed
        changeColorOnScroll={{
          // height: 70,
          // color: "primary",
        }}
        {...rest}
      />
      {/*<Parallax filter image={require("assets/img/landing-bg.jpg")}>*/}
      {/*</Parallax>*/}
      <div className={classNames(classes.main)}>
        <div className={classes.container}>
          <MunicipalityInfo />
        </div>
      </div>
      <Footer />
    </div>
  );
}
